// const newIcon = require("../icons/new.png");
// const bag = require("../icons/bag.png");
// const cloth = require("../icons/cloth.png");
// const gadget = require("../icons/gadget.png");
// const jewellery = require("../icons/jewellery.png");
// const laptop = require("../icons/laptop.png");
// const phone = require("../icons/phone.png");
// const sale = require("../icons/sale.png");
// const souvenir = require("../icons/souvenir.png");
// const watch = require("../icons/watch.png");

import newIcon from "../icons/new.png";
import bag from "../icons/bag.png";
import cloth from "../icons/cloth.png";
import gadget from "../icons/gadget.png";
import jewellery from "../icons/jewellery.png";
import laptop from "../icons/laptop.png";
import phone from "../icons/phone.png";
import sale from "../icons/sale.png";
import souvenir from "../icons/souvenir.png";
import watch from "../icons/watch.png";

import slider0 from "../images/slider0.jpg";
import slider1 from "../images/slider1.jpg";
import slider2 from "../images/slider2.jpg";
import slider3 from "../images/slider3.jpg";

export const localCategories = [
  {
    id: 0,
    name: "New",
    slug: "new",
    icon: newIcon,
  },
  {
    id: 1,
    name: "Sale",
    slug: "sale",
    icon: sale,
  },
  {
    id: 2,
    name: "Clothing",
    slug: "clothes",
    icon: cloth,
  },
  {
    id: 3,
    name: "Bags",
    slug: "bags",
    icon: bag,
  },
  {
    id: 4,
    name: "Laptops",
    slug: "laptops",
    icon: laptop,
  },
  {
    id: 5,
    name: "Mobiles",
    slug: "phones",
    icon: phone,
  },

  {
    id: 9,
    name: "Watch",
    slug: "watches",
    icon: watch,
  },
  {
    id: 6,
    name: "Gadgets",
    slug: "gadgets",
    icon: gadget,
  },
  {
    id: 7,
    name: "Jewellery",
    slug: "jewellery",
    icon: jewellery,
  },
  {
    id: 8,
    name: "Souvenirs",
    slug: "souvenirs",
    icon: souvenir,
  },
];

export const sliderImages = [
  { url: slider0 },
  { url: slider1 },
  { url: slider2 },
  { url: slider3 },
];
